/* vw-theme.js, gedrag van KORFBALINC VLOERWERK 1.0.0. Vanilla, klein,
   volledig op event-delegatie zodat secties in de theme-editor herladen
   kunnen worden zonder her-initialisatie.

   Drie taken:
   1. Mobiel menu-toggle: knoppen met [data-vw-menu-knop] en een
      aria-controls naar het uitklapmenu; aria-expanded wordt bijgehouden,
      Escape sluit.
   2. Cart-teller: elementen met [data-vw-cart-teller] tonen het aantal
      artikelen. Bij het custom event "vw:cart:update" (op document) wordt
      /cart.js opgehaald en de teller bijgewerkt.
   3. Ajax-cart: formulieren met [data-vw-ajax-cart] posten via fetch naar
      hun eigen action (zet die op routes.cart_add_url), dispatchen daarna
      "vw:cart:update" en melden fouten in het Nederlands in een
      aria-live statusregel. */

(function () {
  'use strict';

  var TEKST_FOUT_TOEVOEGEN = 'Toevoegen aan de winkelwagen is niet gelukt. Probeer het opnieuw.';
  var TEKST_TOEGEVOEGD = 'Toegevoegd aan je winkelwagen.';

  /* ---------------------------------------------------------------- */
  /* 1. Mobiel menu-toggle                                             */
  /* ---------------------------------------------------------------- */

  function menuDoel(knop) {
    var doelId = knop.getAttribute('aria-controls');
    return doelId ? document.getElementById(doelId) : null;
  }

  function zetMenu(knop, open) {
    var doel = menuDoel(knop);
    knop.setAttribute('aria-expanded', String(open));
    if (doel) doel.hidden = !open;
  }

  document.addEventListener('click', function (gebeurtenis) {
    var knop = gebeurtenis.target.closest('[data-vw-menu-knop]');
    if (!knop) return;
    var open = knop.getAttribute('aria-expanded') === 'true';
    zetMenu(knop, !open);
  });

  document.addEventListener('keydown', function (gebeurtenis) {
    if (gebeurtenis.key !== 'Escape') return;
    document
      .querySelectorAll('[data-vw-menu-knop][aria-expanded="true"]')
      .forEach(function (knop) {
        zetMenu(knop, false);
        knop.focus();
      });
  });

  /* ---------------------------------------------------------------- */
  /* 2. Cart-teller via het event "vw:cart:update"                     */
  /* ---------------------------------------------------------------- */

  function cartJsUrl() {
    var teller = document.querySelector('[data-vw-cart-teller]');
    var url = teller ? teller.getAttribute('data-vw-cart-js') : '';
    return url || '/cart.js';
  }

  function werkTellersBij(aantal) {
    document.querySelectorAll('[data-vw-cart-teller]').forEach(function (el) {
      el.textContent = String(aantal);
      el.hidden = aantal === 0;
    });
  }

  function haalCartOp() {
    fetch(cartJsUrl(), { headers: { Accept: 'application/json' } })
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('cart niet bereikbaar');
        return antwoord.json();
      })
      .then(function (cart) {
        werkTellersBij(cart.item_count || 0);
      })
      .catch(function () {
        /* Teller bewust laten staan: een mislukte verversing is geen
           fout die de bezoeker hoeft te zien. */
      });
  }

  document.addEventListener('vw:cart:update', haalCartOp);

  /* ---------------------------------------------------------------- */
  /* 3. Ajax-cart voor formulieren met [data-vw-ajax-cart]             */
  /* ---------------------------------------------------------------- */

  function statusElement(formulier) {
    var status = formulier.querySelector('[data-vw-formulier-status]');
    if (!status) {
      status = document.createElement('div');
      status.setAttribute('data-vw-formulier-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.className = 'vw-formulier-status';
      formulier.appendChild(status);
    }
    return status;
  }

  function verstuurNaarCart(formulier) {
    var status = statusElement(formulier);
    var knop = formulier.querySelector('[type="submit"]');
    var actie = formulier.getAttribute('action') || '/cart/add';
    var url = actie.split('?')[0].replace(/\.js$/, '') + '.js';

    status.textContent = '';
    status.classList.remove('vw-formulier-status--fout', 'vw-formulier-status--succes');
    if (knop) knop.disabled = true;

    fetch(url, {
      method: 'POST',
      body: new FormData(formulier),
      headers: { Accept: 'application/json' }
    })
      .then(function (antwoord) {
        return antwoord.json().then(function (data) {
          return { ok: antwoord.ok, data: data };
        });
      })
      .then(function (resultaat) {
        if (!resultaat.ok) {
          /* Shopify geeft de melding in de winkel-taal (Nederlands). */
          var melding = resultaat.data && (resultaat.data.description || resultaat.data.message);
          var fout = new Error(melding || '');
          fout.vwMelding = melding || '';
          throw fout;
        }
        status.classList.add('vw-formulier-status--succes');
        status.textContent = formulier.getAttribute('data-vw-succes-tekst') || TEKST_TOEGEVOEGD;
        document.dispatchEvent(
          new CustomEvent('vw:cart:update', {
            detail: { bron: 'vw-ajax-cart', item: resultaat.data }
          })
        );
      })
      .catch(function (fout) {
        status.classList.add('vw-formulier-status--fout');
        status.textContent =
          (fout && fout.vwMelding) ||
          formulier.getAttribute('data-vw-fout-tekst') ||
          TEKST_FOUT_TOEVOEGEN;
      })
      .finally(function () {
        if (knop) knop.disabled = false;
      });
  }

  document.addEventListener('submit', function (gebeurtenis) {
    var formulier = gebeurtenis.target.closest('form[data-vw-ajax-cart]');
    if (!formulier) return;
    gebeurtenis.preventDefault();
    verstuurNaarCart(formulier);
  });
})();

/* ================================================================== */
/* Header-zoek met live suggesties (Wave 1b).                          */
/*                                                                     */
/* Apart, zelfstandig IIFE-blok: het raakt de cart- en menu-logica     */
/* hierboven niet aan. Het opent en sluit de zoeklaag uit              */
/* sections/header.liquid, haalt productsuggesties op via de Shopify   */
/* Predictive Search API (debounce) en biedt toetsenbordnavigatie      */
/* (pijl omhoog/omlaag, Enter, Escape). Zonder treffers of bij een     */
/* fout valt alles netjes terug op de gewone zoekpagina (het           */
/* formulier post immers gewoon naar routes.search_url).               */
/* ================================================================== */

(function () {
  'use strict';

  var DEBOUNCE_MS = 220;
  var MIN_TEKENS = 2;
  var MAX_SUGGESTIES = 6;

  var TEKST_GEEN_RESULTAAT = 'Geen producten gevonden. Druk op Enter om alles te doorzoeken.';
  var TEKST_FOUT = 'Zoeken lukt even niet. Druk op Enter om de zoekpagina te openen.';
  var TEKST_BEZIG = 'Bezig met zoeken...';

  function alleZoeklagen() {
    return document.querySelectorAll('[data-vw-zoeklaag]');
  }

  function zoekKnopVan(laag) {
    if (!laag || !laag.id) return null;
    return document.querySelector('[data-vw-zoek-knop][aria-controls="' + laag.id + '"]');
  }

  function openZoeklaag(laag) {
    if (!laag) return;
    laag.hidden = false;
    var knop = zoekKnopVan(laag);
    if (knop) knop.setAttribute('aria-expanded', 'true');
    var invoer = laag.querySelector('[data-vw-zoek-invoer]');
    if (invoer) {
      // Focus na de huidige frame, zodat het tonen niet wordt onderbroken.
      window.requestAnimationFrame(function () {
        invoer.focus();
      });
    }
  }

  function sluitZoeklaag(laag, herstelFocus) {
    if (!laag || laag.hidden) return;
    laag.hidden = true;
    var knop = zoekKnopVan(laag);
    if (knop) {
      knop.setAttribute('aria-expanded', 'false');
      if (herstelFocus) knop.focus();
    }
    var invoer = laag.querySelector('[data-vw-zoek-invoer]');
    if (invoer) invoer.setAttribute('aria-expanded', 'false');
    var resultaat = laag.querySelector('[data-vw-zoek-resultaat]');
    if (resultaat) {
      resultaat.hidden = true;
      resultaat.innerHTML = '';
    }
  }

  /* Knop opent de bijbehorende laag (toggle). */
  document.addEventListener('click', function (gebeurtenis) {
    var knop = gebeurtenis.target.closest('[data-vw-zoek-knop]');
    if (!knop) return;
    var doelId = knop.getAttribute('aria-controls');
    var laag = doelId ? document.getElementById(doelId) : null;
    if (!laag) return;
    if (laag.hidden) {
      openZoeklaag(laag);
    } else {
      sluitZoeklaag(laag, true);
    }
  });

  /* Sluitknop in de laag. */
  document.addEventListener('click', function (gebeurtenis) {
    var sluit = gebeurtenis.target.closest('[data-vw-zoek-sluit]');
    if (!sluit) return;
    var laag = sluit.closest('[data-vw-zoeklaag]');
    sluitZoeklaag(laag, true);
  });

  /* Escape sluit een open zoeklaag en zet de focus terug op de knop. */
  document.addEventListener('keydown', function (gebeurtenis) {
    if (gebeurtenis.key !== 'Escape') return;
    alleZoeklagen().forEach(function (laag) {
      if (!laag.hidden) sluitZoeklaag(laag, true);
    });
  });

  function geldigeMoney(cijfers) {
    // cijfers is het bedrag in centen (Shopify predictive search: price in centen-string).
    var getal = parseInt(cijfers, 10);
    if (isNaN(getal)) return '';
    var euro = (getal / 100).toFixed(2).replace('.', ',');
    return '€ ' + euro;
  }

  function bouwResultaat(resultaat, producten, zoekUrl, query) {
    if (!producten.length) {
      resultaat.innerHTML =
        '<p class="vw-zoek-melding">' + TEKST_GEEN_RESULTAAT + '</p>';
      resultaat.hidden = false;
      return;
    }

    var lijst = document.createElement('ul');
    lijst.className = 'vw-zoek-lijst';

    producten.slice(0, MAX_SUGGESTIES).forEach(function (product, index) {
      var item = document.createElement('li');
      item.className = 'vw-zoek-item';
      item.setAttribute('role', 'option');
      item.id = 'vw-zoek-optie-' + index;

      var link = document.createElement('a');
      link.className = 'vw-zoek-link';
      link.href = product.url || zoekUrl;
      link.tabIndex = -1;

      if (product.featured_image && product.featured_image.url) {
        var img = document.createElement('img');
        img.className = 'vw-zoek-item__beeld';
        img.src = product.featured_image.url;
        img.alt = '';
        img.width = 44;
        img.height = 44;
        img.loading = 'lazy';
        link.appendChild(img);
      }

      var tekst = document.createElement('span');
      tekst.className = 'vw-zoek-item__tekst';

      var titel = document.createElement('span');
      titel.className = 'vw-zoek-item__titel';
      titel.textContent = product.title || '';
      tekst.appendChild(titel);

      var prijsBron = '';
      if (product.price_min != null) {
        prijsBron = String(product.price_min);
      } else if (product.price != null) {
        prijsBron = String(product.price);
      }
      var prijsTekst = geldigeMoney(prijsBron);
      if (prijsTekst) {
        var prijs = document.createElement('span');
        prijs.className = 'vw-zoek-item__prijs';
        prijs.textContent = prijsTekst;
        tekst.appendChild(prijs);
      }

      link.appendChild(tekst);
      item.appendChild(link);
      lijst.appendChild(item);
    });

    resultaat.innerHTML = '';
    resultaat.appendChild(lijst);

    // Anker naar alle resultaten onder de suggesties.
    var alle = document.createElement('a');
    alle.className = 'vw-zoek-alle';
    alle.href = zoekUrl + '?q=' + encodeURIComponent(query) + '&type=product';
    alle.textContent = 'Alle resultaten';
    alle.tabIndex = -1;
    resultaat.appendChild(alle);

    resultaat.hidden = false;
  }

  function koppelZoeklaag(laag) {
    var invoer = laag.querySelector('[data-vw-zoek-invoer]');
    var resultaat = laag.querySelector('[data-vw-zoek-resultaat]');
    var formulier = laag.querySelector('[data-vw-zoek-formulier]');
    if (!invoer || !resultaat || !formulier) return;
    if (laag.getAttribute('data-vw-zoek-gekoppeld') === 'true') return;
    laag.setAttribute('data-vw-zoek-gekoppeld', 'true');

    var zoekUrl = formulier.getAttribute('action') || '/search';
    var debounceId = null;
    var huidigVerzoek = null;
    var actieveIndex = -1;

    function focusbareLinks() {
      return Array.prototype.slice.call(resultaat.querySelectorAll('.vw-zoek-link, .vw-zoek-alle'));
    }

    function markeer(index) {
      var links = focusbareLinks();
      links.forEach(function (link, i) {
        if (i === index) {
          link.classList.add('is-actief');
          link.setAttribute('aria-selected', 'true');
          invoer.setAttribute('aria-activedescendant', link.closest('[id]') ? link.closest('[id]').id : '');
        } else {
          link.classList.remove('is-actief');
          link.removeAttribute('aria-selected');
        }
      });
      actieveIndex = index;
    }

    function haalSuggesties(query) {
      if (huidigVerzoek && huidigVerzoek.abort) {
        try {
          huidigVerzoek.abort();
        } catch (e) {
          /* AbortController niet beschikbaar of al afgerond: stil. */
        }
      }

      var basis = '/search/suggest.json';
      var url =
        basis +
        '?q=' +
        encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=' +
        MAX_SUGGESTIES +
        '&resources[options][unavailable_products]=last';

      var controller = null;
      if (window.AbortController) {
        controller = new AbortController();
        huidigVerzoek = controller;
      }

      resultaat.innerHTML = '<p class="vw-zoek-melding">' + TEKST_BEZIG + '</p>';
      resultaat.hidden = false;

      fetch(url, {
        headers: { Accept: 'application/json' },
        signal: controller ? controller.signal : undefined
      })
        .then(function (antwoord) {
          if (!antwoord.ok) throw new Error('zoeken niet bereikbaar');
          return antwoord.json();
        })
        .then(function (data) {
          var producten =
            data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products
              ? data.resources.results.products
              : [];
          actieveIndex = -1;
          invoer.setAttribute('aria-expanded', 'true');
          invoer.removeAttribute('aria-activedescendant');
          bouwResultaat(resultaat, producten, zoekUrl, query);
        })
        .catch(function (fout) {
          if (fout && fout.name === 'AbortError') return;
          resultaat.innerHTML = '<p class="vw-zoek-melding">' + TEKST_FOUT + '</p>';
          resultaat.hidden = false;
        });
    }

    invoer.addEventListener('input', function () {
      var query = invoer.value.trim();
      if (debounceId) window.clearTimeout(debounceId);

      if (query.length < MIN_TEKENS) {
        resultaat.hidden = true;
        resultaat.innerHTML = '';
        invoer.setAttribute('aria-expanded', 'false');
        invoer.removeAttribute('aria-activedescendant');
        return;
      }

      debounceId = window.setTimeout(function () {
        haalSuggesties(query);
      }, DEBOUNCE_MS);
    });

    invoer.addEventListener('keydown', function (gebeurtenis) {
      var links = focusbareLinks();

      if (gebeurtenis.key === 'ArrowDown') {
        if (!links.length) return;
        gebeurtenis.preventDefault();
        var volgende = actieveIndex + 1;
        if (volgende >= links.length) volgende = 0;
        markeer(volgende);
      } else if (gebeurtenis.key === 'ArrowUp') {
        if (!links.length) return;
        gebeurtenis.preventDefault();
        var vorige = actieveIndex - 1;
        if (vorige < 0) vorige = links.length - 1;
        markeer(vorige);
      } else if (gebeurtenis.key === 'Enter') {
        // Met een gemarkeerde suggestie: ga daarheen. Anders gewoon
        // het formulier laten posten naar de zoekpagina.
        if (actieveIndex > -1 && links[actieveIndex]) {
          gebeurtenis.preventDefault();
          window.location.href = links[actieveIndex].href;
        }
      } else if (gebeurtenis.key === 'Home') {
        if (links.length) {
          gebeurtenis.preventDefault();
          markeer(0);
        }
      } else if (gebeurtenis.key === 'End') {
        if (links.length) {
          gebeurtenis.preventDefault();
          markeer(links.length - 1);
        }
      }
    });

    // Klik buiten de laag sluit hem (maar niet de knop zelf, die toggelt).
    document.addEventListener('click', function (gebeurtenis) {
      if (laag.hidden) return;
      if (laag.contains(gebeurtenis.target)) return;
      if (gebeurtenis.target.closest('[data-vw-zoek-knop]')) return;
      sluitZoeklaag(laag, false);
    });
  }

  function koppelAlles() {
    alleZoeklagen().forEach(koppelZoeklaag);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', koppelAlles);
  } else {
    koppelAlles();
  }

  // In de theme-editor kan de header opnieuw laden; koppel dan opnieuw.
  document.addEventListener('shopify:section:load', koppelAlles);
})();

/* ================================================================== */
/* Onlangs bekeken (Wave 2A).                                          */
/*                                                                     */
/* Apart, zelfstandig IIFE-blok: het raakt de cart-, menu- en          */
/* zoeklogica hierboven niet aan. Het onthoudt op een PDP het          */
/* huidige product-handle in localStorage (meest recent eerst,         */
/* ontdubbeld, afgetopt) en vult de sectie [data-vw-recent] met        */
/* kaarten die exact de opmaak van vw-product-card volgen. De          */
/* producten worden opgehaald via de lichte product-json               */
/* (/products/HANDLE.js). Mislukt het ophalen, of is er nog geen       */
/* geschiedenis, dan blijft de sectie verborgen en stil.               */
/* ================================================================== */

(function () {
  'use strict';

  var SLEUTEL = 'vw:onlangs-bekeken';
  var BEWAAR_MAX = 12;

  function leesGeschiedenis() {
    try {
      var ruw = window.localStorage.getItem(SLEUTEL);
      if (!ruw) return [];
      var lijst = JSON.parse(ruw);
      return Array.isArray(lijst) ? lijst.filter(function (h) {
        return typeof h === 'string' && h.length > 0;
      }) : [];
    } catch (fout) {
      /* localStorage geblokkeerd of corrupte waarde: begin leeg. */
      return [];
    }
  }

  function bewaarGeschiedenis(lijst) {
    try {
      window.localStorage.setItem(SLEUTEL, JSON.stringify(lijst.slice(0, BEWAAR_MAX)));
    } catch (fout) {
      /* Niet kunnen bewaren is geen blokkade: stil laten. */
    }
  }

  function onthoud(handle) {
    if (!handle) return;
    var lijst = leesGeschiedenis().filter(function (h) {
      return h !== handle;
    });
    lijst.unshift(handle);
    bewaarGeschiedenis(lijst);
  }

  function euroUitCenten(centen) {
    var getal = Number(centen);
    if (isNaN(getal)) return '';
    return '€ ' + (getal / 100).toFixed(2).replace('.', ',');
  }

  function maakKaart(data, vanafTekst, uitverkochtTekst) {
    var artikel = document.createElement('article');
    artikel.className = 'vw-kaart vw-product-kaart';

    var beeldvak = document.createElement('div');
    beeldvak.className = 'vw-product-kaart__beeldvak';

    if (data.featured_image) {
      var beeldWrap = document.createElement('div');
      beeldWrap.className = 'image vw-product-kaart__beeld';
      var img = document.createElement('img');
      // Vaste vierkante miniatuur, voorkomt layout-shift; lazy want onderaan.
      var basis = String(data.featured_image).split('?')[0];
      img.src = basis + '?width=800&height=800&crop=center';
      img.alt = '';
      img.width = 800;
      img.height = 800;
      img.loading = 'lazy';
      beeldWrap.appendChild(img);
      beeldvak.appendChild(beeldWrap);
    }

    if (data.available === false) {
      var badge = document.createElement('span');
      badge.className = 'vw-badge vw-badge--gedempt vw-product-kaart__uitverkocht';
      badge.textContent = uitverkochtTekst;
      beeldvak.appendChild(badge);
    }

    artikel.appendChild(beeldvak);

    var info = document.createElement('div');
    info.className = 'vw-product-kaart__info';

    var titel = document.createElement('h3');
    titel.className = 'vw-product-kaart__titel';
    var link = document.createElement('a');
    link.className = 'vw-product-kaart__link';
    link.href = data.url || '#';
    link.textContent = data.title || '';
    titel.appendChild(link);
    info.appendChild(titel);

    var prijsWrap = document.createElement('div');
    prijsWrap.className = 'vw-prijs';
    var prijs = document.createElement('span');
    prijs.className = 'vw-prijs__bedrag vw-mono';
    var bedrag = euroUitCenten(data.price);
    prijs.textContent = data.price_varies ? vanafTekst + ' ' + bedrag : bedrag;
    prijsWrap.appendChild(prijs);
    info.appendChild(prijsWrap);

    artikel.appendChild(info);
    return artikel;
  }

  function vulSectie(sectie) {
    if (sectie.getAttribute('data-vw-recent-gevuld') === 'true') return;
    var grid = sectie.querySelector('[data-vw-recent-grid]');
    if (!grid) return;

    var huidig = sectie.getAttribute('data-vw-huidig') || '';
    var max = parseInt(sectie.getAttribute('data-vw-recent-max'), 10);
    if (isNaN(max) || max < 1) max = 6;

    var handles = leesGeschiedenis().filter(function (h) {
      return h !== huidig;
    }).slice(0, max);

    if (!handles.length) return;
    sectie.setAttribute('data-vw-recent-gevuld', 'true');

    var vanafTekst = sectie.getAttribute('data-vw-tekst-vanaf') || 'Vanaf';
    var uitverkochtTekst = sectie.getAttribute('data-vw-tekst-uitverkocht') || 'Uitverkocht';

    // Per handle de product-json ophalen; volgorde behouden via index.
    var resultaten = new Array(handles.length);
    var nogTeGaan = handles.length;

    function klaar() {
      var getoond = 0;
      resultaten.forEach(function (data) {
        if (!data) return;
        var li = document.createElement('li');
        li.appendChild(maakKaart(data, vanafTekst, uitverkochtTekst));
        grid.appendChild(li);
        getoond += 1;
      });
      if (getoond > 0) {
        sectie.hidden = false;
      } else {
        // Niets bruikbaars opgehaald: ruim de markering op zodat een latere
        // navigatie het opnieuw mag proberen.
        sectie.removeAttribute('data-vw-recent-gevuld');
      }
    }

    handles.forEach(function (handle, index) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' }
      })
        .then(function (antwoord) {
          if (!antwoord.ok) throw new Error('product niet bereikbaar');
          return antwoord.json();
        })
        .then(function (data) {
          resultaten[index] = data;
        })
        .catch(function () {
          /* Dit product overslaan: een ontbrekend item is geen fout. */
        })
        .finally(function () {
          nogTeGaan -= 1;
          if (nogTeGaan === 0) klaar();
        });
    });
  }

  function start() {
    // Eerst onthouden (zodat een herhaald bezoek aan hetzelfde product
    // vooraan komt), daarna de sectie(s) vullen.
    document.querySelectorAll('[data-vw-recent][data-vw-huidig]').forEach(function (sectie) {
      onthoud(sectie.getAttribute('data-vw-huidig'));
    });
    document.querySelectorAll('[data-vw-recent]').forEach(vulSectie);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // In de theme-editor kan de sectie opnieuw laden.
  document.addEventListener('shopify:section:load', function (gebeurtenis) {
    var doel = gebeurtenis.target;
    if (doel && doel.querySelectorAll) {
      doel.querySelectorAll('[data-vw-recent][data-vw-huidig]').forEach(function (sectie) {
        onthoud(sectie.getAttribute('data-vw-huidig'));
      });
      doel.querySelectorAll('[data-vw-recent]').forEach(vulSectie);
    }
  });
})();

/* ================================================================== */
/* Winkelwagen-verversing en add-ons (cart-conversie).                 */
/*                                                                     */
/* Apart, zelfstandig IIFE-blok: het raakt de cart-, menu-, zoek- en   */
/* recent-logica hierboven niet aan. Twee taken op de winkelwagen-     */
/* pagina (de sectie draagt [data-vw-cart-root] met een section-id):   */
/*                                                                     */
/* 1. Na een geslaagde ajax-add (het event "vw:cart:update" van de     */
/*    ajax-cart hierboven) wordt deze cart-sectie opnieuw opgehaald    */
/*    via de Section Rendering API (?section_id=ID) en vervangen we de  */
/*    inhoud van de root. Zo kloppen de nieuwe regel, het totaal en de  */
/*    voortgangsbalk, en valt de zojuist toegevoegde add-on uit de      */
/*    lijst (die sluit producten in de wagen uit). Mislukt dat, dan     */
/*    valt het terug op een gewone herlaadbeurt van de pagina.          */
/* 2. Zit er geen vaste add-on-collectie ingesteld, dan staat op het    */
/*    add-on-blok een data-vw-addon-url naar de aanbevelingen           */
/*    (intent complementary). Die halen we los op en schuiven we in     */
/*    het add-on-blok, zodat de aanbevelingen echt complementair zijn.  */
/* ================================================================== */

(function () {
  'use strict';

  var bezigMetVerversen = false;

  function cartRoot() {
    return document.querySelector('[data-vw-cart-root]');
  }

  function sectieUrl(sectionId) {
    // De Section Rendering API rendert de sectie in de huidige paginacontext.
    var pad = window.location.pathname || '/cart';
    return pad + '?section_id=' + encodeURIComponent(sectionId);
  }

  function verversCart() {
    var root = cartRoot();
    if (!root || bezigMetVerversen) return;
    var sectionId = root.getAttribute('data-vw-cart-section-id');
    if (!sectionId) return;
    bezigMetVerversen = true;

    fetch(sectieUrl(sectionId), { headers: { Accept: 'text/html' } })
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('cart-sectie niet bereikbaar');
        return antwoord.text();
      })
      .then(function (tekst) {
        var vers = new DOMParser().parseFromString(tekst, 'text/html');
        var verseRoot = vers.querySelector('[data-vw-cart-root]');
        var huidig = cartRoot();
        if (verseRoot && huidig) {
          huidig.innerHTML = verseRoot.innerHTML;
          // Add-ons opnieuw koppelen voor de verse inhoud.
          laadAddons();
        } else {
          window.location.reload();
        }
      })
      .catch(function () {
        // Betrouwbare terugval: een volledige herlaadbeurt klopt altijd.
        window.location.reload();
      })
      .finally(function () {
        bezigMetVerversen = false;
      });
  }

  function laadAddons() {
    var blok = document.querySelector('[data-vw-cart-addons][data-vw-addon-url]');
    if (!blok || blok.hasAttribute('data-vw-addons-geladen')) return;
    var url = blok.getAttribute('data-vw-addon-url');
    if (!url) return;
    blok.setAttribute('data-vw-addons-geladen', 'true');

    fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (antwoord) {
        if (!antwoord.ok) throw new Error('add-ons niet bereikbaar');
        return antwoord.text();
      })
      .then(function (tekst) {
        var vers = new DOMParser().parseFromString(tekst, 'text/html');
        var versBlok = vers.querySelector('[data-vw-cart-addons]');
        if (versBlok && versBlok.innerHTML.trim().length > 0) {
          blok.innerHTML = versBlok.innerHTML;
        }
      })
      .catch(function () {
        // Stil laten: add-ons zijn een extraatje, geen voorwaarde. De
        // server-side kaarten (indien aanwezig) blijven gewoon staan.
      });
  }

  // De ajax-cart dispatcht dit op document na een geslaagde toevoeging.
  document.addEventListener('vw:cart:update', function (gebeurtenis) {
    if (!cartRoot()) return;
    // Alleen verversen bij een echte toevoeging vanuit de ajax-cart, niet
    // bij andere bronnen die het event mochten dispatchen.
    var bron = gebeurtenis.detail && gebeurtenis.detail.bron;
    if (bron && bron !== 'vw-ajax-cart') return;
    verversCart();
  });

  function start() {
    if (cartRoot()) laadAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // In de theme-editor kan de cart-sectie opnieuw laden.
  document.addEventListener('shopify:section:load', function (gebeurtenis) {
    var doel = gebeurtenis.target;
    if (doel && doel.querySelector && doel.querySelector('[data-vw-cart-root]')) {
      laadAddons();
    }
  });
})();
